import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "./Button";
import { Icon } from "@synergy/icons";
import Theme from "../../../styles/Theme/Theme";

const DropdownStyle = styled.div`
    position: relative;
`;

const Menu = styled.ul`
    position: absolute;
    z-index: 3;
    list-style-type: none;
    margin: 5px 0;
    padding: 0;
    border-radius: 10px;
    width: 100%;
    overflow: hidden; /* Aqui está a solução */
    cursor: pointer;
    
    > li {
        margin: 0;
        padding: 10px 15px;
        background-color: white;
    }
    
    > li:hover {
        background-color: lightgray;
    }
`;

const ButtonDropdown = styled.div`
    display: flex;
    background-color: white;
    border-radius: 20px;
    padding: 5px 10px;
    color: ${({ color }) => color ?? "black"};
    cursor: pointer;
    box-shadow: ${({ boxshadow }) => boxshadow ?? "none"};
    width: fit-content;

    > span {
        margin: 5px 0px;
    }
`;

export const Dropdown = ({ title, children, ...props }) => {
    const [open, setOpen] = useState(false);

    return (
        <DropdownStyle>
            <ButtonDropdown onClick={() => setOpen(!open)} color={Theme.color['blue-4']} boxshadow={props.boxshadow ? Theme.shadow.level3 : null}>
                {props.preIcon ? <Icon
                    iconsize={"md"}
                    icon={props.preIcon}
                    color={"blue-4"}
                    bgColor={"white"}
                    strokeWidth="2"
                /> : null}
                <span>{title}</span>
                {props.postIcon ?
                    <div style={{ marginTop: '4px' }}> 
                        <Icon
                            iconsize={"xs"}
                            icon={!open ? "ChevronDown" : "ChevronUp"}
                            color={"blue-4"}
                            strokeWidth="2"
                        />
                    </div>
                    : null}
            </ButtonDropdown>

            {open ? (
                <Menu>
                    {React.Children.map(children, (child) =>
                        React.cloneElement(child, {
                            onClick: (e) => {
                                if (child.props.onClick) child.props.onClick(e); // Mantém outros eventos no item
                                setOpen(false); // Fecha o dropdown ao clicar
                            }
                        })
                    )}
                </Menu>
            ) : null}
        </DropdownStyle>
    )
}